import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { IPrimarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';
import { DisplayWhenHasModules } from './five-up-utils.js';

export const RenderSideModule = ({
  rightMajor,
  rightMinor,
}: Pick<IPrimarySlotPropsMap, 'rightMajor' | 'rightMinor'>) => {
  return (
    <>
      <DisplayWhenHasModules section={rightMajor}>
        <ModulesLazyLoadWrapper section={getModulesMetaData('five-up-side-rightMajor', rightMajor.modules)}>
          <ModuleArrLoad modules={rightMajor.modules} modulePath={ModulePath.PRIMARY_RIGHT_MAJOR} />
        </ModulesLazyLoadWrapper>
      </DisplayWhenHasModules>

      <DisplayWhenHasModules section={rightMinor}>
        <ModulesLazyLoadWrapper section={getModulesMetaData('five-up-side-rightMinor', rightMinor.modules)}>
          <ModuleArrLoad modules={rightMinor.modules} modulePath={ModulePath.PRIMARY_RIGHT_MINOR} />
        </ModulesLazyLoadWrapper>
      </DisplayWhenHasModules>
    </>
  );
};
